module.exports = __webpack_public_path__ + "img/Mask Group (5).89f212bd.png";